import { createContext } from 'react'

import type { SellPoint } from './sell-points-data-types'

type SellPointsContextType = {
  loading: boolean
  currentSellPoint: SellPoint | null
  handleShowSelector: () => void
}

const defaultContext: SellPointsContextType = {
  loading: true,
  currentSellPoint: null,
  handleShowSelector: () => {},
}

export default createContext<SellPointsContextType>(defaultContext)
